var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_14915)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_325_14915",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_325_14915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4844 20.1537L13.2229 13.8922C12.7229 14.3179 12.1479 14.6474 11.4979 14.8807C10.8479 15.1141 10.1947 15.2307 9.53837 15.2307C7.9367 15.2307 6.58112 14.6763 5.47162 13.5675C4.36228 12.4587 3.80762 11.1039 3.80762 9.50325C3.80762 7.90242 4.36203 6.5465 5.47087 5.4355C6.5797 4.32466 7.93445 3.76925 9.53512 3.76925C11.136 3.76925 12.4919 4.32392 13.6029 5.43325C14.7137 6.54275 15.2691 7.89833 15.2691 9.5C15.2691 10.1948 15.146 10.8672 14.8999 11.5172C14.6537 12.1672 14.3306 12.723 13.9306 13.1845L20.1921 19.4462L19.4844 20.1537ZM9.53837 14.2307C10.8652 14.2307 11.9854 13.774 12.8989 12.8605C13.8124 11.9472 14.2691 10.827 14.2691 9.5C14.2691 8.173 13.8124 7.05283 12.8989 6.1395C11.9854 5.226 10.8652 4.76925 9.53837 4.76925C8.21137 4.76925 7.0912 5.226 6.17787 6.1395C5.26437 7.05283 4.80762 8.173 4.80762 9.5C4.80762 10.827 5.26437 11.9472 6.17787 12.8605C7.0912 13.774 8.21137 14.2307 9.53837 14.2307Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_14915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
};
export default SvgSearch;